import { RouteType } from "constants/RouteType";
import { ForgotPasswordModel } from "model/utilModels/ForgotPasswordModel";
import { AuthService } from "./AuthService";

export class ForgotPasswordService {
 
    static forgotPassword = async (authData: ForgotPasswordModel) => {
      const url = RouteType.ADMIN + RouteType.AUTH + RouteType.FORGOT_PASSWORD;
      const response = await AuthService.postCryptoRequest(url, JSON.stringify(authData))
      return response;
    };
}